import { getStore } from "store";
import me from "models/me";

export default function (redirect) {
    return (nextState, replace, callback) => {
        const store = getStore();
        const brandId = store.getState().scope?.brand?._id;

        if (!brandId) {
            me.unset("last_brand");
            replace({ pathname: redirect, query: nextState.location.query });
        }
        callback();
    };
}
